// Technology logos, keyed by an integration type's `value` (e.g. "earth_ranger"),
// which is the filename in src/images/logos. Built once at module load from the
// bundler's require.context so adding a PNG is all it takes to show a logo.
//
// Shared by every surface that names a technology — the provider picker, the
// Connection header, the destination-type dropdown — so a logo added for one of
// them appears in all of them.
const buildLogoMap = (): Record<string, string> => {
    try {
        const context = (require as any).context('../../images/logos', false, /\.png$/);
        const map: Record<string, string> = {};
        context.keys().forEach((key: string) => {
            const id = key.replace('./', '').replace('.png', '');
            // CRA 5 bundles PNGs as webpack asset modules with esModule: true, so
            // require.context returns the module namespace ({ default: url }), not
            // the URL. Rendering that object gave every logo src="[object Object]".
            // Unwrap defensively so a non-esModule bundler still works.
            const mod = context(key);
            map[id] = (mod && mod.default) || mod;
        });
        return map;
    } catch {
        // No require.context (jest, or a non-webpack bundler): callers render
        // their no-logo fallback instead.
        return {};
    }
};

const logoMap = buildLogoMap();

export const getTechnologyLogo = (typeValue?: string): string | null =>
    (typeValue && logoMap[typeValue]) || null;
